export const formatNumberWithCommas = (value: string | number | null | undefined): string => {
  if (!value && value !== 0) return ''
  const numStr = value.toString().replace(/,/g, '')
  // Return empty string if not a valid number
  if (numStr === '' || isNaN(Number(numStr))) return ''
  const num = parseInt(numStr, 10)
  if (isNaN(num)) return ''
  return num.toLocaleString('en-US')
}

export const removeCommas = (value: string): string => {
  // Remove all non-numeric characters except for leading numbers
  return value.replace(/[^\d]/g, '')
}

export const months = [
  { key: 'January', value: 'January', label: 'January' },
  { key: 'February', value: 'February', label: 'February' },
  { key: 'March', value: 'March', label: 'March' },
  { key: 'April', value: 'April', label: 'April' },
  { key: 'May', value: 'May', label: 'May' },
  { key: 'June', value: 'June', label: 'June' },
  { key: 'July', value: 'July', label: 'July' },
  { key: 'August', value: 'August', label: 'August' },
  { key: 'September', value: 'September', label: 'September' },
  { key: 'October', value: 'October', label: 'October' },
  { key: 'November', value: 'November', label: 'November' },
  { key: 'December', value: 'December', label: 'December' },
]

export const abrMonths = [
  { key: 'January', value: 'January', label: 'Jan' },
  { key: 'February', value: 'February', label: 'Feb' },
  { key: 'March', value: 'March', label: 'Mar' },
  { key: 'April', value: 'April', label: 'Apr' },
  { key: 'May', value: 'May', label: 'May' },
  { key: 'June', value: 'June', label: 'Jun' },
  { key: 'July', value: 'July', label: 'Jul' },
  { key: 'August', value: 'August', label: 'Aug' },
  { key: 'September', value: 'September', label: 'Sep' },
  { key: 'October', value: 'October', label: 'Oct' },
  { key: 'November', value: 'November', label: 'Nov' },
  { key: 'December', value: 'December', label: 'Dec' },
]

export const days = [
  { key: '1', value: '1' },
  { key: '2', value: '2' },
  { key: '3', value: '3' },
  { key: '4', value: '4' },
  { key: '5', value: '5' },
  { key: '6', value: '6' },
  { key: '7', value: '7' },
  { key: '8', value: '8' },
  { key: '9', value: '9' },
  { key: '10', value: '10' },
  { key: '11', value: '11' },
  { key: '12', value: '12' },
  { key: '13', value: '13' },
  { key: '14', value: '14' },
  { key: '15', value: '15' },
  { key: '16', value: '16' },
  { key: '17', value: '17' },
  { key: '18', value: '18' },
  { key: '19', value: '19' },
  { key: '20', value: '20' },
  { key: '21', value: '21' },
  { key: '22', value: '22' },
  { key: '23', value: '23' },
  { key: '24', value: '24' },
  { key: '25', value: '25' },
  { key: '26', value: '26' },
  { key: '27', value: '27' },
  { key: '28', value: '28' },
  { key: '29', value: '29' },
  { key: '30', value: '30' },
  { key: '31', value: '31' },
]
